import { ApiKey } from "../CocopeatDashboard/CoocpeatHome";

async function getAddressFromCoords(lat, lon) {

  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${ApiKey}`
  );

  const data = await response.json();

  if (data.status === "OK" && data.results.length > 0) {
    return data.results[0].formatted_address; // full readable address
  } else {
    throw new Error("Unable to get address");
  }
}

export default getAddressFromCoords;
